export default function CustomTagInput({ value, onChange }) {
  return (
    <section className="custom-tag-wrapper">
      <input
        type="text"
        className="custom-tag-input"
        placeholder="Optional: Enter custom tag"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </section>
  );
}